import type {
  BlogListParams,
  BlogPost,
  DefaultResponseBody,
  ListResponseBody,
} from "@gerama/types";
import type { ApiClient } from "../client";

export function createCoreBlogApi(client: ApiClient) {
  return {
    list: (params: BlogListParams = {}, signal?: AbortSignal) =>
      client
        .request<ListResponseBody<BlogPost>>("/blog", { query: { ...params }, signal })
        .then((res) => res.data ?? { list: [], count: 0 }),

    /** `x-lang` picks which locale's title/body resolves — the server returns exactly one already-picked language. */
    detail: (slug: string, lang: "fa" | "en" = "fa", signal?: AbortSignal) =>
      client
        .request<DefaultResponseBody<BlogPost>>(`/blog/${slug}`, {
          signal,
          headers: { "x-lang": lang },
        })
        .then((res) => res.data as BlogPost),
  };
}
